import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/langs'
import gtm from '@/plugins/gtm'
import gtag from '@/plugins/gtag'
import fbq from '@/plugins/fbq'
import ym from '@/plugins/ym'
import '@/derectives'

const env = process.env.NODE_ENV

window.axios = require('axios')
window.Vue = Vue

Vue.config.productionTip = false

Vue.use(gtm, {
	// id: 'GTM-MC8H4GH',
	env,
})

Vue.use(gtag, {
	// id: 'UA-134623459-10',
	env,
})

Vue.use(fbq, {
	// id: '1304604706379492',
	env,
	router,
})

Vue.use(ym, {
	id: 59210668,
	env,
	router,
	params: {
		clickmap: true,
		trackLinks: true,
		accurateTrackBounce: true,
		webvisor: true,
	},
})

new Vue({
	i18n,
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
